/*
|-------------------------------------------------------------------------------
| 端上数据
|-------------------------------------------------------------------------------
*/
import { defineStore } from '~/utils/store'
import type { IStoreState } from '~/utils/store'

const nativeStore = defineStore({
  state: () => ({
    /**
     * 摄像头
     */
    camera: '',
    /**
     * 通讯录
     */
    contact: '',
    /**
     * 地理位置
     */
    location: '',
    /**
     * 端内收集的信息，从安全部 sdk 获取到的，透传即可（加密串）
     */
    bizSystemInfo: '',
    /**
     * 端内收集，通讯录信息，加密串
     */
    contactInfo: '',
  }),
  mutations: {
    update(state, data) {
      Object.assign(state, data)
    },
    saveBizSystemInfo(state, payload) {
      state.bizSystemInfo = payload
    },
  },
})
export default nativeStore
export type INativeStoreState = IStoreState<
  typeof nativeStore.state
>
